<template>
  <workbench-w-canvas-slot :loading="loading"
                           :metrics="toolbarMetrics"
                           :target-name="targetName"
                           :activated="activated"
                           :header-menu="dynamicHeaderMenu">

    <workbench-row ref="topRow" :style="{ height: topRow}">

      <audience-size class="workbench__audience workbench__canvas-block" :size="audienceSize"></audience-size>

      <div class="workbench__canvas-block workbench__additional-attributes">
          <tabs class="workbench__stretch-canvas-block">
            <!-- <tab name="Additional Social Affinity">
              <top-common-attributes :attributes="topSocialAffinity"></top-common-attributes>
              <api-error-message v-if="!topSocialAffinity" apiName="top social attributes data"></api-error-message>
            </tab> -->
            <tab name="Additional TSP Attributes">
              <top-common-attributes :attributes="topTsp"></top-common-attributes>
              <api-error-message v-if="!topTsp" apiName="top tsp attributes data"></api-error-message>
            </tab>
          </tabs>
        </div>

    </workbench-row>

    <workbench-row class="workbench__property-engagement-row" :style="{ height: bottomRow}">
      <!-- Need to put new property reach/engagement chart here -->
      <!-- <property-engagement :brands="reach" class="workbench__canvas-block"></property-engagement> -->
      <api-error-message v-if="!reach" apiName="reach and engagement data"></api-error-message>
    </workbench-row>

    <confirm-modal ref="confirmModal"/>

  </workbench-w-canvas-slot>
</template>

<script>
  import { ResizeSensor } from 'css-element-queries'
  import WorkbenchWCanvasSlot from '@/views/workbenchCanvas/WorkbenchWCanvasSlot'
  import ConfirmModal from '@/appComponents/oldWorkbench/confirmModal/ConfirmModal'
  import WorkbenchRow from '@/views/workbenchCanvas/WorkbenchRow'
  import AudienceSize from '@/appComponents/oldWorkbench/audienceSize/AudienceSize'
  import PropertyEngagement from '@/appComponents/oldWorkbench/propertyEngagementReach/PropertyEngagementReach'
  import TabsComponents from '@/components/common/tabs'
  import TopCommonAttributes from '@/appComponents/oldWorkbench/topCommonAttributes/TopCommonAttributes'
  import ApiErrorMessage from '@/appComponents/workbench/apiErrorMessage/ApiErrorMessage'
  import CommonMixins from '@/views/workbench/mixins/CommonWorkbenchMixins'
  import {ACTIVATION_STATUS} from '@/appLogic/targets/Constants.js'

  const { Tabs, Tab } = TabsComponents

  export default {
    components: {
      WorkbenchWCanvasSlot,
      WorkbenchRow,
      AudienceSize,
      PropertyEngagement,
      Tabs,
      Tab,
      TopCommonAttributes,
      ApiErrorMessage,
      ConfirmModal
    },
    mixins: [CommonMixins],
    data () {
      return {
        topRow: null,
        bottomRow: null,
        namespace: 'sm'
      }
    },
    computed: {
      audienceSize () {
        const currentTarget = this.$store.getters.currentTarget
        return currentTarget && currentTarget.audience_size ? currentTarget.audience_size : this.$store.getters.audienceSize
      },
      topTsp () {
        return this.$store.getters.topTsp
      },
      topSocialAffinity () {
        return this.$store.getters.topSocialAffinity
      },
      reach () {
        return this.$store.getters.reach
      },
      activated () {
        if (this.$store.state.currentTarget.currentTarget) {
          return this.$store.state.currentTarget.currentTarget.activation_status === ACTIVATION_STATUS.ACTIVATED
        }
      }
    },
    methods: {
      setRowSizes () {
        let canvasHeight = this.canvasEl.clientHeight
        let vp = 0.7
        let up = 0.3
        // canvas graphs min height
        if (canvasHeight < 480) {
          canvasHeight = 480
        }
        // help fit universe graph on smaller screens
        if (canvasHeight < 650) {
          vp = 0.85
          up = 0.15
        }
        this.topRow = canvasHeight * vp - 15 + 'px'
        this.bottomRow = canvasHeight * up - 15 + 'px'
      }
    },
    mounted () {
      // eslint-disable-next-line no-undef
      adobeAnalytics.viewSMWorkbench()
      this.canvasEl = document.querySelector('#canvas')
      document.querySelector('html').classList.add('workbench-resize')
      this.setRowSizes()
      ResizeSensor(this.canvasEl, () => {
        this.setRowSizes()
      })
    }
  }
</script>

<style lang="scss">
  $side-panel-width: rem(380);
  $audience-size-width: rem(140);
  $margin-size: rem(10);


  .workbench {

    &__viewership {
      position: relative;
      width: calc(100% - #{$audience-size-width + $margin-size});
    }

    &__day-parts {
      flex: 1 100%;
      max-width: 100%;
    }

    &__audience {
      width: $audience-size-width;
      flex: none;
    }

    &__universe {
      position: relative;
      width: 100%;
    }
  }

  .workbench__property-engagement-row {
    position: relative;
  }

  .workbench__additional-attributes {
    flex: 1 1;
  }

  .workbench__sm-top {
    height: calc(60% - 15px);
  }

  .workbench__stretch-canvas-block {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    padding: 20px;
  }

  .sm {
    width: 100%;
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// Sm.vue?022abefb